<script lang="ts" setup>
import type { Article } from '~/types'

interface Props {
  article: Article.Model
}

const props = defineProps<Props>()

const { categories, contentBlocks, team, type } = useArticle(props.article)
provide('currentTeam', team)
</script>

<template>
  <div class="article">
    <ArticleHero
      :article
      class="article__hero"
    />
    <AdPlacement
      :team="team ?? undefined"
      class="article__ad article__ad--start"
    />
    <ContentBlocks
      :content-blocks
      class="article__content-blocks"
    />
    <AdPlacement
      :team="team ?? undefined"
      class="article__ad article__ad--end"
    />
    <ArticleRelated
      :article-id="article.id"
      :categories
      :team="team ?? undefined"
      :type
      class="article__related"
    />
  </div>
</template>
